<template>
  <div>
    <div class="card">
      <div class="card-body">
        <b-row>
          <div class="col">
            <h5 class="mb-4">
              <strong>{{ isEditingSchool ? 'Editar' : 'Crear'}} institución</strong>
            </h5>
          </div>
        </b-row>
        <b-form v-on:keydown.enter.prevent>
          <b-row>
            <div class="col-md-7">
              <b-row class="ml-1">
                <div class="col-sm-9 col-md-10 col-lg-10 col-xl-6 col-9">
                  <b-form-group id="input-group-1" label="Nombre:" label-for="input-1">
                    <b-form-input id="input-1" v-model="form.name" placeholder="Ingrese el nombre"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-6 col-9">
                  <b-form-group id="input-group-2" label="Dirección:" label-for="input-2">
                    <b-form-input id="input-2" v-model="form.address" placeholder="Ingrese la dirección"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-6 col-9">
                  <b-form-group id="input-group-3" label="Email:" label-for="input-3">
                    <b-form-input id="input-3" v-model="form.email" placeholder="Ingrese el email"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-6 col-9">
                  <b-form-group id="input-group-4" label="Teléfono:" label-for="input-4">
                    <b-form-input id="input-4" v-model="form.phone" placeholder="Ingrese el númerico teléfonico"></b-form-input>
                  </b-form-group>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-10 col-xl-6 col-9">
                  <b-form-group id="input-group-6" label="Zona horaria:" label-for="input-6">
                  <b-form-select v-model="form.timeZoneSelect" :options="timeZoneClient"></b-form-select>
                </b-form-group>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-12 col-xl-11 col-9">
                  <a-button @click="openModal()" class="btn btn-outline-secondary">Habilitar módulos</a-button>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-12 col-xl-11 col-9 mt-2">
                  <p class="m-auto p-auto">{{ activeModulesText }}</p>
                </div>
                <div class="col-sm-10 col-md-10 col-lg-12 col-xl-11 col-9">
                  <b-button @click="save()" variant="primary" class="mr-2 mb-3 mt-3">{{ isEditingSchool ? 'Guardar cambios' : 'Crear'}}</b-button>
                  <router-link to="/schools" class="btn mr-2 mb-3 mt-3 btn-light btn-sm">
                    Cancelar e ir a lista
                  </router-link>
                </div>
              </b-row>
            </div>
            <div class="col-md-4">
              <b-row class="justify-content-center">
                <img :src="form.logo"
                @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                width="175" alt="..." class="img-thumbnail img-fluid" style="display: block; margin-left: auto; margin-right: auto;"><br/>
                <div class="col-xl-10" style="max-width:300px">
                  <b-form-file
                    @change="onFileChange"
                    placeholder="Seleccione una imagen"
                    drop-placeholder="Suelta la imagen aquí"
                    accept="image/jpeg, image/png, image/gif"
                    browse-text="Buscar imagen"
                    v-model="file"
                  ></b-form-file>
                  <p class="text-secondary">La imagen no debe superar las 5MB</p>
                </div>
              </b-row>
            </div>
          </b-row>
          <b-modal id="activate-modules" ref="modal" size="lg" title="Habilitar módulos" hide-footer>
            <div class="row justify-content-md-center">
              <div class="col-12 col-sm-5">
                <div class="card bg-light py-3 px-2" style="overflow-y: scroll; height: 30rem;">
                  <h3 class="font-weight-bold text-dark font-size-18 mb-3">Módulos disponibles</h3>
                  <draggable :list="modules" group="board">
                    <div :class="$style.card" v-for="(item) in modules" :key="item.id">
                      <div :class="$style.content">
                        <div :class="[$style.flag, 'bg-' + item.color]"></div>
                        <div class="d-flex flex-wrap-reverse align-items-center">
                          <h5 class="text-dark font-size-18 mb-0">{{item.name}}</h5>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
              <div class="col-12 col-sm-5">
                <div class="card bg-light py-3 px-2" style="overflow-y: scroll; height: 30rem;">
                  <h3 class="font-weight-bold text-dark font-size-18 mb-3">Módulos habilitados</h3>
                  <draggable :list="activeModules" group="board" @change="draggableChange">
                    <div :class="$style.card" v-for="(item) in activeModules" :key="item.id">
                      <div :class="$style.content">
                        <div :class="[$style.flag, 'bg-' + item.color]"></div>
                        <div class="d-flex flex-wrap-reverse align-items-center">
                          <h5 class="text-dark font-size-18 mb-0">{{item.name}}</h5>
                        </div>
                      </div>
                    </div>
                  </draggable>
                </div>
              </div>
            </div>
            <div class="row justify-content-md-center">
              <div class="col-12 col-sm-1">
                <b-button variant="primary" @click="onHidden()">Listo</b-button>
              </div>
            </div>
          </b-modal>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import apiClient from '@/services/axios'
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  components: {
    draggable,
  },
  name: 'schoolManagementArea',
  data() {
    return {
      isEditingSchool: false,
      file: null,
      image: null,
      fileUrl: '',
      modules: [
        { value: '1', name: 'Academico' },
        { value: '2', name: 'Biblioteca' },
        { value: '3', name: 'Cafetería' },
        { value: '4', name: 'Tesorería' },
        { value: '5', name: 'Inventario' },
        { value: '6', name: 'Asistencia' },
        { value: '7', name: 'Observador' },
        { value: '8', name: 'Nómina' },
      ],
      activeModules: [],
      activeModulesText: '',
      timeZoneClient: Intl.supportedValuesOf('timeZone'),
      form: {
        name: '',
        address: '',
        email: '',
        phone: '',
        logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png',
        timeZoneSelect: 'America/Bogota',
      },
    }
  },
  computed: {
    ...mapState(['user']),
  },
  watch: {
    $route (to, from) {
      this.isEditingSchool = typeof to.params.idUser !== 'undefined'
      if (!this.isEditingSchool) {
        this.form = {
          name: '',
          email: '',
          phone: '',
          address: '',
          logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Placeholder_no_text.svg/1200px-Placeholder_no_text.svg.png',
          timeZoneSelect: '',
        }
        this.file = null
      }
    },
    activeModules: function (x) {
      this.activeModulesText = 'Habilitados: '
      for (let index = 0; index < x.length; index++) {
        if (index === x.length - 1) {
          this.activeModulesText += x[index].name
        } else {
          this.activeModulesText += x[index].name + ', '
        }
      }
    },
  },
  beforeRouteEnter (to, from, next) {
    function getSchool() {
      return apiClient.get('/schools/' + to.params.idSchool)
    }

    if (to.params.idSchool) {
      axios.all([getSchool()])
        .then(axios.spread(function (schoolToEdit) {
          next((vm) => {
            vm.setDataSchoolEdit(null, schoolToEdit.data)
          })
        }))
        .catch(err => {
          next((vm) => {
            vm.setDataSchoolEdit(err, [])
          })
        })
    } else {
      next()
    }
  },
  methods: {
    setDataSchoolEdit (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.isEditingSchool = true
        this.form = data
        this.form.timeZoneSelect = data.timeZone
        console.log(data)
        if (data.academicModule) {
          this.activeModules.push(this.modules[0])
        }
        if (data.libraryModule) {
          this.activeModules.push(this.modules[1])
        }
        if (data.cafeteriaModule) {
          this.activeModules.push(this.modules[2])
        }
        if (data.treasuryModule) {
          this.activeModules.push(this.modules[3])
        }
        if (data.inventoryModule) {
          this.activeModules.push(this.modules[4])
        }
        if (data.attendanceModule) {
          this.activeModules.push(this.modules[5])
        }
        if (data.observerModule) {
          this.activeModules.push(this.modules[6])
        }
        this.activeModules.forEach((value, index) => {
          for (let i = 0; i < this.modules.length; i++) {
            if (this.activeModules[index].value === this.modules[i].value) {
              this.modules.splice(i, 1)
            }
          }
        })
        this.form.pathAvatar = `${data.pathAvatar}?tr=w-300`
      }
    },
    onFileChange(e) {
      this.image = e.target.files[0]
      this.fileUrl = URL.createObjectURL(this.image)
      this.form.logo = this.fileUrl
    },
    async onHidden (e) {
      this.$bvModal.hide('activate-modules')
    },
    save(evt) {
      if (evt) {
        evt.preventDefault()
      }
      this.form.name = this.form.name.trim()
      this.form.email = this.form.email.trim()
      if (!this.form.name) {
        this.$notification.warning({
          message: 'Nombre inválido',
          description: 'El nombre está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (!this.form.phone) {
        this.$notification.warning({
          message: 'Telefono inválido',
          description: 'El telefono está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (!this.form.address) {
        this.$notification.warning({
          message: 'Dirección inválida',
          description: 'La dirección está vacía o no cumple con las características requeridas',
        })
        return
      }
      if (!this.form.email) {
        this.$notification.warning({
          message: 'Email inválido',
          description: 'El Email/correo está vacío o no cumple con las características requeridas',
        })
        return
      }
      if (this.isEditingSchool) {
        const sentParams = {
          name: this.form.name,
          address: this.form.address,
          phone: this.form.phone,
          email: this.form.email,
          modules: this.activeModules,
          timeZone: this.form.timeZoneSelect,
        }
        apiClient.patch(`/schools/${this.form.id}`, { sentParams: sentParams }).then(response => {
          this.$notification.success({
            message: 'Cambio guardado',
            description: 'La institución ' + response.data.name + ' ha sido actualizado exitosamente.',
          })
          return this.saveImage(this.form.id) // Se retorna promesa
        }).catch(error => {
          console.log(error)
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: error.message ? error.message : error.response.data.errors.msg,
          })
        })
      } else {
        const sentParams = {
          name: this.form.name,
          address: this.form.address,
          phone: this.form.phone,
          email: this.form.email,
          modules: this.activeModules,
          timeZone: this.form.timeZoneSelect,
        }
        apiClient.post('/schools', { sentParams: sentParams }).then(response => {
          this.$notification.success({
            message: 'Institución guardada',
            description: 'La institución ' + response.data.name + ' ha sido guardada exitosamente.',
          })
          return this.saveImage(response.data.id) // Se retorna promesa
        }).catch(error => {
          console.log(error)
          this.$notification.error({
            message: 'Ooops ocurrió un error',
            description: error.message ? error.message : error.response.data.errors.msg,
          })
        })
      }
    },
    draggableChange(evt) {
      /* console.log(this.activeModules, 2) */
    },
    saveImage(idSchool) {
      if (this.file) { // Sube la foto de perfil
        if (this.file.size > 5000000) {
          return Promise.reject(new Error('La imagen tiene ' + (this.file.size / 1000000) + 'MB y no puede superar las 5MB'))
        }
        const formData = new FormData()
        formData.append('file', this.file)
        return apiClient.post('/schools/' + idSchool + '/schoolImage',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )
      } else {
        return new Promise((resolve, reject) => {
          resolve('noFile')
        })
      }
    },
    openModal() { // Abre el modal para habilitar módulos
      this.$bvModal.show('activate-modules')
    },
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
